import { DepreciationMethodId } from '@assetaccountant/api/models/depreciation-method-id';
import { DepreciationRuleId } from '@assetaccountant/api/models/depreciation-rule-id';
import { DepreciationRuleDto } from '@assetaccountant/api/models/depreciation-rule.dto';
import { DepreciationMethodKey } from './depreciation-method';

export function ruleIsValidForPool(ruleId: DepreciationRuleId, poolCode?: string | null) {
  switch (ruleId) {
    case DepreciationRuleId.CA_Tax_AcceleratedInvestmentIncentive:
    case DepreciationRuleId.CA_Tax_ReacceleratedInvestmentIncentive:
      return poolCode == null || (poolCode !== 'CA_C12' && poolCode !== 'CA_C53');
    case DepreciationRuleId.CA_Tax_Class12HalfYearRule:
      return poolCode == null || poolCode === 'CA_C12';
    default:
      return false;
  }
}

export function ruleIsValidForMethod(
  ruleId: DepreciationRuleId,
  depreciationMethodId?: DepreciationMethodId | DepreciationMethodKey | null,
) {
  switch (ruleId) {
    case DepreciationRuleId.CA_Tax_Class12HalfYearRule:
      return false;
  }
  switch (depreciationMethodId) {
    case DepreciationMethodId.US_Tax_Section197:
      return false;
    case DepreciationMethodId.CA_Tax_NoDepreciation:
    case DepreciationMethodId.CA_Tax_Immediate:
    case DepreciationMethodId.CA_Tax_DoesntExist:
    case DepreciationMethodId.CA_Tax_NotCapitalised:
      return (
        ruleId !== DepreciationRuleId.CA_Tax_AcceleratedInvestmentIncentive &&
        ruleId !== DepreciationRuleId.CA_Tax_ReacceleratedInvestmentIncentive
      );
  }

  return true;
}

export function getRuleName(
  rule: DepreciationRuleDto,
  _firstUseDate: string,
  _opts: { poolCode?: string | null },
  _refOpts: { referenceStartDate: string },
) {
  return rule.name;
}
